let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("lBQ2X")]).then(() => parcelRequire('aMXh0'));